
/**
 * angular imports
 */
import { Component, OnInit, OnDestroy, AfterViewInit, Input, EventEmitter, Output, NgZone } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { Renderer2 } from '@angular/core';
import { ElementRef } from '@angular/core';
/**
 * model import
 */
import { promoStrip } from 'src/app/onboarding/interface/global.model';
import { AnalyticsInterface, EventDataKey } from 'src/app/analytics-event/analytics.model';
import { EVENT_NAME } from 'src/app/analytics-event/analytics.constant';
import { PRODUCT_TYPE_CONSTANT, PRODUCT_TYPE_CONSTANT_NAME } from 'src/app/constants/app.constants';
/**
 * service imports
 */
import { GetService } from 'src/app/dataservices/get.service';
import { PostApiService } from 'src/app/dataservices/post-api.service';
/**
 * rxjs imports
 */
import { Subscription, timer } from 'rxjs';
import { tap } from 'rxjs/operators';
import { takeWhile } from 'rxjs/operators';
/**
 * constant imports
 */
import { NUMBERS } from 'src/app/constants/app.constants';

/**
 * SDK imports
 */
import { Analytics } from 'analytics2.0';
/**
 * component to generate promo strip
 */
@Component({
  selector: 'app-promo-strip',
  templateUrl: './promo-strip.component.html',
  styleUrls: ['./promo-strip.component.scss'],
})
export class PromoStripComponent implements OnInit, OnDestroy, AfterViewInit {
  ngAfterViewInit(): void {
    this.anchors = this.elementRef.nativeElement.querySelectorAll('a');
    this.anchors.forEach((anchor: HTMLAnchorElement) => {
      anchor.addEventListener('click', this.listenClick);
    });
    if (this.closeType === NUMBERS.TWO.toString()) {
      document.getElementById('close')?.classList.add('d-none');
    }
  }
  /**
   * vairable for elemnet
   */
  public anchors;
  /**
   * TO store promo data
   */
  public pvsData: promoStrip;
  /**
   * current time
   */
  public currentTime: number;
  /**
   * subscription
   */
  public subscriptions: Subscription;
  /**
   * Analyticsdata object.
   */
  public analyticsData: AnalyticsInterface;
  /**
   * timer flag
   */
  public timerFlag = true;
  /*
  /**
   * to store HTML data
   */
  @Input() pvsHtml: SafeHtml;
  /**
   * cross button flag
   */
  @Input() closeType: string;
  /**
   * pvs id
   */
  @Input() pvsId: number;
  /**
   * end time
   */
  @Input() endTime: number;
  /**
   * input for start time
   */
  @Input() startTime: number;

  @Input() currentScreenName: string;
  /**
   * to emit close event
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() hideStrip: EventEmitter<any> = new EventEmitter();
  constructor(
    private getService: GetService,
    private domSantize: DomSanitizer,
    private postService: PostApiService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private zone: NgZone,
    private analyticSdk: Analytics
  ) {
   }
  ngOnInit(): void {
    const currentTime = Date.now();
    if (currentTime > this.endTime) {
      // this.emitHideStrip(false);
    }
    this.startTimer();
    this.timerFlag = true;

  }
  /**
   * button events
   */
  public listenClick = (event: Event): void => {
    // Prevent opening anchors the default way
    event.preventDefault();
    const element = event.target as HTMLAnchorElement;
    const elementValue = JSON.parse(element.getAttribute('data'));
    const screen_name = elementValue?.cta_name;
    const href = element.getAttribute('href');
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.PVS, this.pvsId, this.currentScreenName,elementValue?.cta_type, elementValue?.action_type, elementValue?.cta_name, null);
    if (element.id !== 'close') {
      window.open(href, '_blank');
    }
    if (element.id === 'close') {
      this.closeStrip();
    }
  };

  /**
   * Get the current time in string.
   */
  getTimeString(): string {
      return new Date().getTime().toString();
  }
  /**
   * start count down timer.
   */
  startTimer(): void {
    this.zone.runOutsideAngular(() => {
       timer(0, 1000).pipe(
        tap(() => {
          this.currentTime = Math.round(Date.now() / 1000);
        }),
        takeWhile(() => this.timerFlag == true ),
        tap(() => {
          if (this.currentTime > this.endTime || this.currentTime < this.startTime ) {
            this.zone.run(() => {
              this.timerFlag = false;
              this.hideStrip.emit(false);
            });
          }
        })
      ).subscribe();
    });
  }
  /**
   * emitting hide strip
   */
  emitHideStrip(status: boolean): void {
    this.hideStrip.emit(status);
    sessionStorage.setItem('pvsCrossed'+ this.pvsId, 'true');
  }
  /**
   *
   * funtion to close strip
   */
  closeStrip(): void {
    if (this.closeType  === NUMBERS.ONE.toString()) {
      this.emitHideStrip(false);
    }
    else if (this.closeType === NUMBERS.THREE.toString()) {
      this.closeStripForver();
    }
  }
  /**
   * close forever strip
   */
  public closeStripForver(): void {
    this.postService.closePVS(this.pvsId).subscribe(data => {
      if (data.status) {
        this.emitHideStrip(false);
      }
    });
  }
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }

  }
}
